/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebPublicConfiguration } from '../shiva-web-public-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FeatureCollection } from '../models/feature-collection';
import { getMapFiltersPublic } from '../fn/map/get-map-filters-public';
import { GetMapFiltersPublic$Params } from '../fn/map/get-map-filters-public';
import { getMapStations } from '../fn/map/get-map-stations';
import { GetMapStations$Params } from '../fn/map/get-map-stations';
import { MapFilters } from '../models/map-filters';

@Injectable({ providedIn: 'root' })
export class MapService extends BaseService {
  constructor(config: ShivaWebPublicConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMapStations()` */
  static readonly GetMapStationsPath = '/map/public';

  /**
   * retrieve stations geolocalized on map.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMapStations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMapStations$Response(params: GetMapStations$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureCollection>> {
    return getMapStations(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve stations geolocalized on map.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMapStations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getMapStations(params: GetMapStations$Params, context?: HttpContext): Observable<FeatureCollection> {
    return this.getMapStations$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeatureCollection>): FeatureCollection => r.body)
    );
  }

  /** Path part for operation `getMapFiltersPublic()` */
  static readonly GetMapFiltersPublicPath = '/map/public/filters/types';

  /**
   * retrieve map filters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMapFiltersPublic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMapFiltersPublic$Response(params?: GetMapFiltersPublic$Params, context?: HttpContext): Observable<StrictHttpResponse<MapFilters>> {
    return getMapFiltersPublic(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieve map filters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMapFiltersPublic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMapFiltersPublic(params?: GetMapFiltersPublic$Params, context?: HttpContext): Observable<MapFilters> {
    return this.getMapFiltersPublic$Response(params, context).pipe(
      map((r: StrictHttpResponse<MapFilters>): MapFilters => r.body)
    );
  }

}
